<div  class="row" style="height: 480px;" [ngStyle]="{'width' : currentItem.selected ?'max-content' : '250px'}" >
  <div
    style="
      overflow-y: auto;
      height: 480px;
      width: 250px;
      padding: 15px 0 15px 0;
    "
  >
    <div
      class="menu-filtro panel-heading-container"
      *ngFor="let item of menu"
      (mouseenter)="item.selected = true; currentItem = item"
      (click)="item.selected = false"
    >
      <div
        class="panel-heading-container"
        *ngIf="item.children.length; else elseBlockNotHasChildren"
      >
        <button
          data-toggle="collapse"
          type="button"
          class="panel-heading btn-panel {{ item.selected ? '' : 'collapsed' }}"
          (click)="onClick(item.description, item.children, item)"
        >
          {{ item.description }}
        </button>
        <!-- <div
          id="box{{ item.id }}"
          class="dropdown-box list-group list-group-flush panel-collapse collapse {{
            item.selected ? 'show' : ''
          }}"
        >
          <app-treeview-link
            #submenu
            (onSelect)="onSelect($event)"
            *ngFor="let subItem of item.children"
            [item]="subItem"
            [selected]="subItem.selected"
            [parent]="item.description"
            (breadCrumb)="saveBc($event)"
          ></app-treeview-link>
        </div> -->
      </div>
      <hr />
      <ng-template #elseBlockNotHasChildren>
        <a
          (click)="selectRoot(item.id, item.description)"
          style="cursor: pointer"
          class="panel-heading-no-subtitle"
          >{{ item.description }}</a
        >
      </ng-template>
    </div>
  </div>
  <div
  id="box{{ currentItem.id }}"
  class="list-group list-group-flush panel-collapse collapse {{
    currentItem.selected ? 'show' : ''
  }}"
    style="
      width: 250px;
      background-color: #fff;
      height: 480px;
      padding-top: 15px;
      overflow-y: auto;
    "
  >
    <app-treeview-link
      #submenu
      (onSelect)="onSelect($event)"
      *ngFor="let subItem of currentItem.children"
      [item]="subItem"
      [selected]="subItem.selected"
      [parent]="currentItem.description"
      (breadCrumb)="saveBc($event)"
    ></app-treeview-link>
  </div>
</div>
